import React, { useState, useFetch } from "react";
//import ReportsPage from "./ReportsPage";
import "./ReportTabs/ReportCss/Login.css"
// import { browserHistory } from 'react-router'
// import api from '../services/httpService';
import axios from 'axios';


const Login = ({ navigation }) => {

  const [inputId, setInputId] = useState('');
  const [inputPass, setInputPass] = useState('');
  const [error, setError] = useState(''); 
  // const [enterDateTime, setEnterDateTime] = useState(new Date());
 

  var resData = [];
 


   async function ValidateInternal(e) {

    
    localStorage.clear();
   
    var errorMsg = "";
    var listSpclChars = ["SELECT", " OR", "'", "/", "--"];
    if(listSpclChars.some((specialChar) => inputId.includes(specialChar)))
    {
      console.log('44');
      e.preventDefault();
      setError('יש להכניס נתונים תקינים');
      alert('יש להכניס נתונים תקינים');
      return false;
    }
   
    if (inputId.length > 3 && inputPass.length > 0
       && !inputId.toUpperCase().includes("SELECT")  && !inputId.toUpperCase().includes(" OR ") && !inputId.includes("'")  && !inputId.includes("/") && !inputId.includes("--") 
       && !inputPass.toUpperCase().includes("SELECT")  && !inputPass.toUpperCase().includes(" OR ")  && !inputPass.includes("'") && !inputPass.includes("/")  && !inputPass.includes("--")) {
      setError(errorMsg)
      const url = 'https://proxy.tuboul.co.il/Login?id=' + inputId + '&pass=' + inputPass + '&computer=my&dateTime=202208211650 ';
      console.log(url);

      // setEnterDateTime(new Date())
      //

      try {
 

        
      const api = axios.create({
        baseURL: process.env.REACT_APP_BASE_URL,
        headers: {
          'Content-Type': 'text/json',
        },
        auth: {
          username: process.env.REACT_APP_AUTH_USERNAME ,
          password: process.env.REACT_APP_AUTH_PASSWORD ,
        },
      });

        console.log('Login');
      //  console.log("param id:" +loginData.id );     

      const res = await axios.get("https://api.ipify.org/?format=json");
      const ip = res.data.ip;
        
       const response = await api.get(`/Login?id=` + inputId + '&pass=' + inputPass + '&computer='+ip+'&dateTime=202208211650 ')
        console.log('response1: ' +response.data);
        debugger;
       
        //return response.data;
        resData = response.data;
      } catch (error) {
        e.preventDefault();
        console.log('error ');
        errorMsg ="error"; 
        setError('יש להכניס פרטים תקינים');
        // toasterService.error(error);
        // return rejectAction();
        return false;
      }

      //

      // debugger;
      // await fetch(url)
      //   .then((response) => response.json())
      //   .then((res) => { resData = res; debugger;})
      //   //.then((res) => AfterGetData())setData(res);
      //   .catch((error) => {
      //     debugger;
      //     e.preventDefault();
      //     console.log('error-- ' + error); errorMsg ="error"; setError('יש להכניס פרטים תקינים');

      //     // alert('יש להכניס נתונים תקינים');
      //     // return false;
      //   })
        // .finally(() => {
         
          if (errorMsg.length > 0 || resData.valid == undefined || resData.valid < 0) {
            
            e.preventDefault(); 
            alert('יש להכניס נתונים תקינים');
            return false;
          }

          console.log('6');
          localStorage.setItem("id", inputId);
          localStorage.setItem("pass", inputPass); 
          localStorage.setItem("dt", new Date());
          localStorage.setItem("proj", JSON.stringify(resData));//data

          console.log('11');
          console.log(localStorage.getItem("proj"));
     

       //   browserHistory.push('/ReportsPage')
       document.getElementById("frmLogin").submit();
          return true;
        //});
    }
    else {
      console.log('4');
      e.preventDefault();
      setError('יש להכניס נתונים תקינים');
      alert('יש להכניס נתונים תקינים');
      return false;
    }
    debugger;
  }





  return (
    <div >
      <link href="//maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" rel="stylesheet" id="bootstrap-css" />
      <script src="//maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js"></script>
      <script src="//code.jquery.com/jquery-1.11.1.min.js"></script>
      <div class="sidenav">
        <div class="login-main-text">
          <h2>אתר קבלנים</h2>
          <h2>כניסה</h2>
          <p>Login or register from here to access.</p>
        </div>
      </div>
      <div class="main">
        <div class="col-md-6 col-sm-12">
          <div class="login-form">
            <form id="frmLogin"  action="/ReportsPage" >
            {/* onSubmit={Validate} */}
              <div class="form-group">
                <label>שם משתמש / ת.ז / ח.פ</label>
                <input type="text" class="form-control" placeholder="שם משתמש / ת.ז / ח.פ" required
                  value={inputId} onInput={e => setInputId(e.target.value)} />
              </div>
              <div class="form-group">
                <label>סיסמה</label>
                <input type="password" class="form-control" placeholder="סיסמה" value={inputPass} onInput={e => setInputPass(e.target.value)} />
              </div>
              {/*COMAND  */}
              <p>{error}</p>
              <button type="button" onClick={ValidateInternal} class="btn btn-black">כניסה</button>
              {/* onSubmit={Validate} */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );

}

//
//<button type="submit" class="btn btn-secondary">Register</button>
// navigation.navigate('ReportsPage');
export default Login;